import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {AvatarPlaceholder} from '../../../../uikit/AvatarPlaceholder';
import {Checkbox} from '../../../../uikit/Checkbox';
import * as S from './styles';

export const RequestsListItemJSX: FC<Props> = ({
  avatarUrl,
  courseLabel,
  createdAt,
  onAcceptClick,
  onDeclineClick,
  onMoreClick,
  onSelectClick,
  selected,
  username,
}) => {
  const {t} = useI18n();

  return (
    <S.Container>
      <Checkbox checked={selected} onClick={onSelectClick} />
      <S.Avatar
        placeholder={<AvatarPlaceholder text={username} />}
        src={avatarUrl ?? ''}
      />
      <S.InfoContainer>
        <S.MainTruncatedText>{username}</S.MainTruncatedText>
        <S.CreatedAt>{createdAt}</S.CreatedAt>
      </S.InfoContainer>
      {courseLabel ? (
        <>
          <S.CalendarIcon />
          <S.MainTruncatedText>{courseLabel}</S.MainTruncatedText>
        </>
      ) : null}
      <S.RightContainer>
        <S.ActionButton disabled={!onAcceptClick} onClick={onAcceptClick}>
          {t('shared:accept')}
        </S.ActionButton>
        <S.ActionButton
          disabled={!onDeclineClick}
          onClick={onDeclineClick}
          scheme="danger"
        >
          {t('shared:decline')}
        </S.ActionButton>
        {onMoreClick ? (
          <S.MoreButton onClick={onMoreClick}>
            <S.MoreIcon />
          </S.MoreButton>
        ) : null}
      </S.RightContainer>
    </S.Container>
  );
};
